import { combineReducers } from 'redux';
import mobileBanner from './mobileBanner';
import desktopBanner from './desktopBanner';

export default combineReducers({
  mobileBanner,
  desktopBanner,
});
